import { NgModule, APP_INITIALIZER, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { KreFormModule, Default_CODE, KreForm } from "@kre-form/core";

import { KreFormIonicModule } from "@kre-form/ionic";
import { IonicModule } from "@ionic/angular";
import { UIIONICComponent } from "./index.component";
import { IonFieldDemoTypeComponent } from "./component/demo.type";

const entryComponents = [UIIONICComponent, IonFieldDemoTypeComponent];
const routes: Routes = [
  {
    path: "",
    component: UIIONICComponent,
  },
  {
    path: "ionic",
    component: UIIONICComponent,
  },
];

// @NgModule({
//   declarations: [...entryComponents],
//   entryComponents: [...entryComponents],
//   imports: [
//     CommonModule,
//     ReactiveFormsModule,
//     RouterModule.forChild(routes),
//     ReactiveFormsModule,
//     KreFormModule.forRoot(),
//     KreFormIonicModule,
//     IonicModule.forRoot()
//   ]
// })
// export class UIIONICModule {}

@NgModule({
  declarations: [...entryComponents],
  entryComponents: [...entryComponents],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    KreFormModule.forConfig(
      "84e1a5936fe23d544abc4c020703320f96dff20f0398b4332fc328c0a5cd789aa80406c6a280aebccfc4fe50bd9fa50e"
    ),
    KreFormModule.forRoot({
      types: [{ name: "demo", component: IonFieldDemoTypeComponent }],
    }),

    KreFormIonicModule,

    IonicModule.forRoot(),
  ],
})
export class UIIONICModule {
  constructor(@Inject(APP_INITIALIZER) appInitialize) {
    appInitialize[0]();
  }
}
